<div class="title-box p-3">
    <div class="title mx-auto" i18n="terms: page title">DP Foundation Privacy Principles</div>
</div>
<section class="section-about">
    <div class="container">
        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Privacy Principles</h6>
            <p>Our Privacy Policy is fueled by our commitment to these Privacy Principles:</p>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">1. We’re deeply committed to creating a safe and secure online environment for 
                you.</h6>
            </div>

        <div class="inner mb-4">
            <h6 class="mb-4">2. We do not sell your personal information to third parties. We established DP 
                Foundation as a not-for-profit organization so that our mission of education and 
                your trust will not be in conflict with a for-profit motive.
            </h6>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">3. We strive to provide you with access to and control over the information you give 
                us, and we take the protection of your information very seriously.
            </h6>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">4. We take extra precautions for our younger learners.</h6>
        </div>

        <div class="inner mb-4">
            <h6 class="mb-4">5. We do not display advertising on DP Foundation. Our mission is to provide you 
            with a world class education, not to sell you products</h6>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Overview</h6>
            
           <p>Dhammika and Priscilla Perera Foundation (“DP Foundation”) is a Sri Lankan-based 
            charitable not-for-profit organization. As a part of the mission to eliminate poverty 
            in the country by developing human capabilities, Dhammika and Priscilla Perera 
            Foundation launched DP Education (“our”, “us”, or “we”) as its digital education 
            arm. As a not-for-profit, we use the information we collect to provide you with a 
            better experience and fulfill our mission of providing a free, world- class education 
            for anyone, anywhere. We established ourselves as a not-for-profit organization so 
            that a for-profit motive will not interfere with our mission of providing a trusted 
            educational resource.</p>

            <p>We are committed to protecting your privacy. We understand how important privacy 
                is to you, and we are committed to protecting your privacy and to creating a safe and 
                secure environment for learners of all ages. This Privacy Policy explains how 
                information is collected, used, shared, and protected by DP Education when you use 
                (or access) our website at www.dpeducation.lk, our mobile application, and online 
                service (collectively, our “Service”). DP Education of Dhammika and Priscilla 
                Perera Foundation built the DP Education app as a free app. This service is provided 
                by DP Education at no cost and is intended for use as is</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Collection of information</h6>
            <p>
                We collect information in the following ways, depending on your use of the Service:
            </p>
            
            <ul>
                <li>
                    We collect information from you directly, such as when you register, 
                    communicate with us, participate in learning activities, events or surveys, or 
                    otherwise provide information during your use of the Service despite the 
                    device being used
                </li>
                <li>
                    We may collect information from others, such as your Schools, or third parties 
                    (meaning organizations outside of DP Foundation), such as third-party 
                    applications that you use to connect to the Service.
                </li>
                <li>
                    We collect some information automatically, such as information about your 
                    use of the Service and the devices you use to access the Service. We may use 
                    cookies, pixels, and similar technologies to collect information.
                </li>
            </ul>

            <p>Examples of information we may collect includes:</p>
            <ul>
                <li>
                    Service access information (username, birthdate, and email)
                </li>
                <li>Service use information (usage times, grade, interested programs)</li>
                <li>Information about your browser or device, IP address, and general location</li>
                <li>Information you provide us when you contact us for help</li>
                <li>Information you enter into our system when using the service, such as while 
                    asking doubts, and participating in discussions.</li>
                <li>Information you choose to include in your profile or post in public areas of 
                    the Service</li>
                <li>Non-personal information which may be linked to your personal information, 
                    including Information about your use of our Service</li>
                <li>Information on the type of mobile device you use, your mobile devices unique 
                    device ID, the IP address of your mobile device, your mobile operating 
                    system, the type of mobile Internet browsers you use, and information about 
                    the way you use the Application/Services/product collected automatically.
                </li>
                
            </ul>

        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Use of information</h6>
            
            <p>DP Foundation uses information collected for the purposes of:</p>
            <ul>
                <li>
                    providing the Service
                </li>
                <li>personalizing your experience and better your learning objectives</li>
                <li>communicating with you about your account and our Service (including 
                    responding to inquiries and sharing information about new features and 
                    offerings that may be of interest)</li>
                <li>enabling your participation in special programs that we may offer in 
                    partnerships with third parties (if you choose to participate in such special 
                    programs)</li>
                <li>understanding and improving our Service, and developing new or improved 
                    educational offerings</li>
                <li>analyzing usage patterns and trends to better the experience of all users.</li>
            </ul>

            <p>
                We may also use de-identified or aggregated information for product development, 
                research, analytics and other purposes, including for the purpose of analyzing, 
                improving or marketing our Service, for demonstrating the impact of our Service, or 
                conducting educational research.
            </p>

        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Sharing and disclosure of information</h6>
            <p>DP Foundation takes great care to protect the personal information you provide to 
                us. We do not sell, trade, or share your personal information to third parties. This 
                section explains circumstances in which we may share personal information with 
                third parties.
            </p>
            <p>We may share personal information:</p>
            <ul>
                <li>
                    with other users of our Service, if you use features that enable you to share 
                    your information with (or make it accessible to) others.
                </li>
                <li>
                    with Vendors, consultants and other service providers working on our behalf
                    (does not contain any of your Personally Identifiable Information).
                </li>
                <li>
                    with other users that are associated with your account, such as a parent, 
                    teacher, or coach.
                </li>
                <li>
                    with your consent (including third party applications that you choose to use, 
                    such as complementary services or an Authentication Service). If you choose 
                    to use a third-party application or service, the use of your information by the 
                    third party will be governed by that party’s privacy policy.
                </li>
                <li>
                    for compliance purposes, such as when reasonably necessary to protect the 
                    security and safety of our users or Service, or when permitted by law.
                </li>
            </ul>
            <p>We may also share de-identified or aggregated information that does not reasonably 
                identify any individual.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Access to your Personal Information</h6>
            <p>
                We will provide you with the means to ensure that your Personal Information is 
                correct and current. If you have filled out a user profile, we will provide an obvious 
                way for you to access and change your profile from our Application/ Services/ 
                Website. We adopt reasonable security measures to protect your password from 
                being exposed or disclosed to anyone.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Sponsorship and Advertising</h6>
            
            <p>DP Foundation does not display third-party advertisements on our Service. We may, 
                from time to time, incorporate content or link to content provided by third parties 
                that may be of interest to you and relevant to the educational context of our Service. 
                Some of these materials or websites may include branding or advertisements as 
                permitted by the third-party owner or operator. For more information, please review 
                Links to third parties.
            </p>
            <p>
                Please note that we use our best efforts and take multiple steps to avoid the collection 
                of information for targeted advertising purposes when we believe the Service is 
                being used by Students or Children
            </p>
            <ul>
                <li>For example, we take steps to inhibit third-party advertising networks from 
                    collecting information for targeted advertising purposes on webpages with 
                    child-directed content or when a Student or Child User uses the Service.
                </li>
                <li>DP Foundation uses the available privacy functionality in YouTube to display 
                    video content on YouTube</li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Links to Third Parties</h6>
            
            <p>The Service may link to and may be linked by websites operated by other entities or 
                individuals. If we include links to third-parties and you click on that link, you will 
                be leaving DP Foundation and the privacy policy of that third-party applies. 
                Similarly, if you see a link to DP Foundation on a third-party website, then the 
                privacy policy of that third-party applies.</p>
                <ul>
                    <li>This DP Foundation Privacy Policy does not apply to (and we cannot control 
                        the activities of) such other third-party websites.
                    </li>
                    <li>You should consult the privacy policies of those third-party websites.</li>
                </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Cookies</h6>
            
            <p> We send cookies (small files containing a string of characters) to your computer, 
                thereby uniquely identifying your browser. Cookies are used to track your 
                preferences, help you login faster, and aggregated to determine user trends. This data 
                is used to improve our offerings, such as providing more content in areas of greater 
                interest to a majority of users. Most browsers are initially set up to accept cookies, 
                but you can reset your browser to refuse all cookies or to indicate when a cookie is 
                being sent. Some of our features and services may not function properly if your 
                cookies are disabled
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Discussion Forums</h6>
            
            <p>
                When you use certain features on our website like the discussion forums and you 
                post or share your personal information such as comments, messages, files, photos, 
                will be available to all users, and will be in the public domain. All such sharing of 
                information is done at your own risk. Please keep in mind that if you disclose 
                personal information in your profile or when posting on our forums this information 
                may become publicly available.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Security</h6>
            <p>
                We are concerned about safeguarding the confidentiality of your Information. We 
                provide physical, electronic, and procedural safeguards to protect Information we 
                process and maintain. For example, we limit access to this Information to authorized 
                employees only who need to know that information in order to operate, develop or 
                improve our Application/Services/products/Website. Please be aware that, although 
                we endeavor to provide reasonable security for information we process and maintain, 
                no security system can prevent all potential security breaches.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Changes to this privacy policy</h6>
            
            <p>DP Foundation may modify or revise this Privacy Policy from time to time. DP 
                Foundation will notify users of any changes to our Privacy Policy by posting the 
                revised Privacy Policy with an updated date of revision on our Service. If we change 
                this Policy in a material manner, we will do our best to notify you of the changes by 
                posting a notice on our website. We recommend that you review the Privacy Policy 
                each time you visit the Service to stay informed of our privacy practices.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">How Long Do We Retain User Data?</h6>
            
            <p>Currently, we retain user data while an account is active and for at least three years 
                afterward. We may alter this practice according to legal and operational 
                requirements. For example, we may lengthen the retention period for some data if 
                needed to comply with law or voluntary codes of conduct. Unless otherwise 
                prohibited, we may shorten the retention period for some types of data if needed to 
                free up storage space.</p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Log information</h6>
            
            <p>
                When you access our website or application, our servers automatically record 
                information that your browser sends whenever you visit a website. These server logs 
                may include information such as your web request, internet protocol address, 
                browser type, browser language, the date and time of your request and one or more 
                cookies that may uniquely identify your browser
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">User communications</h6>
            
            <p>
                When you send an email or connect via other communication methods, we may 
                retain those communications in order to process your inquiries, respond to your 
                requests and improve our Services.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Contact DP Foundation</h6>
            
            <p>
                Please contact DP Foundation with any questions, comments, or queries. 
            </p>

            <ul>
                <li>
                    By email: <a href="mailto:info@dpfoundation.org.lk">info@dpfoundation.org.lk</a>
                </li>
                <li>
                    By mail: Dhammika & Priscilla Perera Foundation, 29th Floor, West Tower, World Trade Center, Colombo 01, Sri Lanka
                </li>
            </ul>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Regional information</h6>
            
            <p>
                This Regional information notice supplements our Privacy Policy. In certain regions, 
                you may have certain additional rights. This may include the right to request access 
                or to update or review your information, request that it be deleted or anonymized, or 
                object to or restrict DP Foundation using it for certain purposes.
            </p>

            <p>
                If you wish to exercise a right, please Contact DP Foundation. Our ability to respond 
                to specific requests may be limited by applicable law and the functionality of our 
                Service.
            </p>
            <p>
                International Data Transfer: Our Service is operated and managed on servers located 
                within Sri Lanka. If you choose to use our Service from any other location in the 
                world with laws governing data collection and use that differ from law in Sri Lanka, 
                then you acknowledge that DP Foundation will transfer, store, and process your 
                personal information to Sri Lanka for the purpose of performing the Service and for 
                any other purpose for which you provide explicit, informed consent.
            </p>
        </div>

        <div class="inner mb-4">
            <h6 class="fw-bold mb-4">Legal</h6>
            
            <p>
                This Privacy Policy is structured and governed in accordance with the Sri Lanka 
                Personal Data Protection Act No. 9. We strive to uphold the highest standards of 
                legal compliance and are committed to protecting the confidentiality, integrity, and 
                availability of your personal data as outlined in the above Act
            </p>
        </div>
    </div>
</section>
